<template>
  <v-card class="base-card shadow">
    <v-card-title class="headline accent--text pb-4"> Страницы размещения авторской части в издании </v-card-title>

    <v-card-text>
      <CardRow
        label="Страницы"
        :disabled="isShowMode"
        :required="Boolean(!isShowMode && (monography.pageFrom || monography.pageTo))"
        :value="`c ${monography.pageFrom} по ${monography.pageTo}`"
      >
        <v-row class="mt-0 mb-0">
          <v-col
            cols="6"
            class="py-0"
          >
            <UITextField
              class="rounded-lg mini-text field-edit required"
              v-model="monography.pageFrom"
              type="number"
              placeholder="c"
              outlined
              dense
              single-line
              :disabled="isShowMode"
              :hide-details="!Boolean(errorMessages.pageFrom.length)"
              :error-messages="errorMessages.pageFrom"
              @input="
                $v.monography.pageFrom.$touch()
                updateMonography()
              "
            />
          </v-col>

          <v-col
            cols="6"
            class="py-0"
          >
            <UITextField
              class="rounded-lg mini-text field-edit required"
              v-model="monography.pageTo"
              type="number"
              placeholder="по"
              outlined
              dense
              single-line
              :disabled="isShowMode"
              :hide-details="!Boolean(errorMessages.pageTo.length)"
              :error-messages="errorMessages.pageTo"
              @input="
                $v.monography.pageTo.$touch()
                updateMonography()
              "
            />
          </v-col>
        </v-row>
      </CardRow>

      <CardFieldRow
        v-model="monography.authoPartName"
        label="Название авторской части главы"
        placeholder="Добавьте название авторской части главы"
        :disabled="isShowMode"
        :error-messages="errorMessages.authoPartName"
        @input="
          $v.monography.authoPartName.$touch()
          updateMonography()
        "
      />

      <CardFieldRow
        v-model="monography.authoPartPage"
        type="number"
        label="Номер авторской части главы"
        placeholder="Добавьте номер авторской части главы"
        :disabled="isShowMode"
        @input="updateMonography()"
      />

      <CardFieldRow
        v-model="monography.redactor"
        label="Редакторы"
        placeholder="Добавьте редакторов"
        hint="Формат: И.О. Ивановой, И.О. Петровой, ..."
        :persistent-hint="true"
        :disabled="isShowMode"
        :error-messages="errorMessages.redactor"
        :required="!isShowMode"
        @input="
          $v.monography.redactor.$touch()
          updateMonography()
        "
      />

      <CardFieldRow
        v-model="monography.series"
        label="Серия"
        placeholder="Добавьте серию"
        :disabled="isShowMode"
        @input="updateMonography()"
      />

      <CardFieldRow
        v-model="monography.isbn"
        label="ISBN"
        placeholder="Добавьте ISBN"
        :disabled="isShowMode"
        :error-messages="errorMessages.isbn"
        :required="!isShowMode"
        @input="
          $v.monography.isbn.$touch()
          updateMonography()
        "
      />

      <CardFieldRow
        v-model="monography.edition"
        type="number"
        label="Тираж"
        placeholder="Добавьте тираж"
        :disabled="isShowMode"
        :error-messages="errorMessages.edition"
        :required="!isShowMode"
        @input="
          $v.monography.edition.$touch()
          updateMonography()
        "
      />

      <CardTextAreaRow
        v-model="monography.fullBibliographicDescription"
        label="Полное библиографическое описание"
        placeholder="Формируется автоматически при заполнении всех обязательных полей"
        :disabled="isShowMode"
        readonly
        hide-border-bottom
      />
    </v-card-text>
  </v-card>
</template>

<script>
import { Monography } from '@/models'
import CardRow from '@/components/ui/row/CardRow'
import { between, maxLength, required, requiredIf } from 'vuelidate/lib/validators'
import { setValidateMessages, regexFrom1To9999, regexFrom1To10M } from '../../../scripts/validation'
import CardFieldRow from '../../ui/row/CardFieldRow'
import CardTextAreaRow from '../../ui/row/CardTextAreaRow'
import UITextField from '@/components/ui/UITextField.vue'

export default {
  components: { UITextField, CardTextAreaRow, CardFieldRow, CardRow },
  props: {
    isShowMode: Boolean,
    selectedItem: Object
  },

  mounted() {
    this.updateInvalid()
  },

  data: () => ({
    monography: new Monography()
  }),

  validations() {
    return {
      monography: {
        pageFrom: { required: requiredIf(() => Boolean(this.monography.pageTo)), regexFrom1To9999 },
        pageTo: {
          required: requiredIf(() => Boolean(this.monography.pageFrom)),
          regexFrom1To9999,
          between: between(this.monography.pageFrom || 1, 9999)
        },
        authoPartName: { maxLength: maxLength(500) },
        redactor: { required, maxLength: maxLength(500) },
        isbn: { required, maxLength: maxLength(50) },
        edition: { required, regexFrom1To10M }
      }
    }
  },

  computed: {
    errorMessages() {
      const allErrors = {}

      Object.keys(this.$v.monography.$params).forEach(key => {
        allErrors[key] = setValidateMessages(this.$v.monography[key])
      })

      return allErrors
    }
  },

  methods: {
    updateInvalid() {
      this.$emit('updateInvalid', this.$v.$invalid)
    },

    async updateMonography() {
      this.$emit('update:selected-item', this.monography)
      this.updateInvalid()
    }
  },

  watch: {
    selectedItem: {
      immediate: true,
      deep: true,
      handler(val) {
        this.monography = new Monography(val.getForAPI())
        this.updateInvalid()
      }
    }
  }
}
</script>

<style scoped></style>
